import React from 'react';
import propTypes from 'prop-types';

import { useLocale } from '../Internationalization';
import { getLocalizedPageUrl } from '../Navigation';
import Button from '../../components/Button';

const Link = ({ to: pageName, ...props }) => {
  const locale = useLocale();
  const link = getLocalizedPageUrl(pageName, locale);
  return <Button {...props} type="link" href={link} />;
};

Link.propTypes = {
  to: propTypes.string.isRequired,
};

export default Link;



// WEBPACK FOOTER //
// ./src/modules/Link/index.js